import React from "react";

const RequestSection = ({ title, data, unit }) => (
  <div className="request-section">
    <h3>{title}</h3>
    {typeof data === "object" ? (
      <>
        <p>{data?.name || data?.partner_name || data?.verified_by}</p>
        <p>{data?.phone || data?.partner_phone || data?.verified_at}</p>
      </>
    ) : (
      <p>
        {data} {unit}
      </p>
    )}
  </div>
);

export default RequestSection;
